import { render, staticRenderFns } from "./list-project.vue?vue&type=template&id=6f231a5e&scoped=true&"
import script from "./list-project.vue?vue&type=script&lang=js&"
export * from "./list-project.vue?vue&type=script&lang=js&"
import style0 from "./list-project.vue?vue&type=style&index=0&id=6f231a5e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f231a5e",
  null
  
)

export default component.exports